import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type TextProps = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold';
};

export const Text: React.FC<TextProps> = ({ children, weight = 'regular', style, ...props }) => {
  return (
    <RNText style={[s.common, s.text, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
